// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__lGLcm","name":"ConsentHeader_name__NPLF_","birthday":"ConsentHeader_birthday__1iyzg","skeleton":"ConsentHeader_skeleton__nsjw6"};